import { Duration } from 'luxon';
export function formatDuration(minutes, pluralizeUnits = false) {
    const hourStr = minutes >= 120 && pluralizeUnits ? 'hours' : 'hour';
    const minuteStr = pluralizeUnits ? 'minutes' : 'minute';
    const format =
        (minutes >= 60 ? `h '${hourStr}'` : '') +
        (minutes % 60 > 0 ? ` m '${minuteStr}'` : '');
    return Duration.fromObject({ minutes: minutes }).toFormat(format);
}
